import { z } from "zod"

export const themeSchema = z.object({
  headerBackground: z.string(),
  footerBackground: z.string(),
  primaryColour: z.string(),
  secondaryColour: z.string(),
  linkText: z.string(),
  navText: z.string(),
  primaryButtonText: z.string(),
  secondaryButtonText: z.string(),
  primaryCardText: z.string(),
  secondaryCardText: z.string(),
  borders: z.string(),
  headingFont: z.object({
    label: z.string(),
    value: z.string(),
  }),
  baseFont: z.object({
    label: z.string(),
    value: z.string(),
  }),
})

export type ThemeValues = z.infer<typeof themeSchema>
